













































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.min.css'
import UserApi from '@/api/user'
import VisitorApi from '@/api/visitor'
import cloneDeep from 'lodash/cloneDeep'
import { debounce } from '@/utils/util'
import AreaApi from '@/api/area'
import { values } from 'lodash'
import { idCard } from '@/utils/validator'
let cropper: any = ''
let NORMAL_VISITOR = '43000'
const debounceSearch = debounce(300)

@Component({})
export default class SaveVisitor extends Vue {
	@Prop()
	private value!: boolean

	@Prop()
	private selected!: any

	@Prop()
	private visitorRoles!: any

	private visible: boolean = false
	private loading: boolean = false
	private form: any = {}
	private first: boolean = true
	private companyOptions: any = []
	private imgURL: any = ''
	private searchArea: any = []
	private fetching: any = false
	private normalVisitor = NORMAL_VISITOR
	private manageAreas: any = []
	private manageAreaMap: any = {}
	private isCityLeaf = false
	private isAreaLeaf = false
	private showManageTree = false

	private fileList: any = []
	private fileListIdBack: any = []
	private idFrontInfo: any = {}
	private idBackInfo: any = {}

	private previewVisible = false
	private previewVisibleIdBack = false

	private created() {
		this.form = this.$form.createForm(this)
	}

	private get isUpdate() {
		return !!this.selected
	}

	// 关闭模态框
	private handleCancel() {
		this.previewVisible = false
	}
	// 打开模态框（图片预览）
	private handlePreview(file: any) {
		this.previewVisible = true
	}

	private handleRemove() {
		this.fileList = []
		this.idFrontInfo = {}
	}

	private setAgeSexImpl(idNo: any) {
		if (idNo.length == 18) {
			var sCardNum = idNo.substring(16, 17)
			var sex = parseInt(sCardNum) % 2 == 1 ? '男' : '女'

			var year = parseInt(idNo.substring(6, 10))
			var now = new Date()
			var age = now.getFullYear() - year
			this.form.setFieldsValue({
				sex: sex,
				age: age,
			})
		} else if (idNo.length == 15) {
			sCardNum = idNo.substring(14, 15)
			sex = parseInt(sCardNum) % 2 == 1 ? '男' : '女'

			year = parseInt(idNo.substring(6, 8)) + 1900
			now = new Date()
			age = now.getFullYear() - year
			this.form.setFieldsValue({
				sex: sex,
				age: age,
			})
		}
	}

	private setAgeSex(e: any) {
		var idNo = e.target.value
		this.setAgeSexImpl(idNo)
	}

	private beforeUpload(e: any) {
		this.fileList = []
		this.idFrontInfo = {}
		if (e.size > 2 * 1024 * 1024) {
			this.$message.error('文件大小不能超过2M')
			return false
		}
		const formData = new FormData()
		formData.append('filecontent', e)
		// recognizeIdCard
		VisitorApi.recognizeIdCard({
			formData,
			// params: {operateAndUpload
			// 	cmd: 'imageMogr2/thumbnail/800x800',
			// },
		}).then((res: any) => {
			this.fileList = [e]
			this.idFrontInfo = res.data
			this.form.setFieldsValue({
				name: res.data.name,
				idNo: res.data.id_number,
			})

			this.$message.success('上传成功')
			if (!idCard(this.form.idNo)) {
				this.form.setFieldsValue({
					idNo: '',
				})
				this.$message.error('身份证校验失败，请重新识别', 3)
			} else {
				this.setAgeSexImpl(res.data.id_number)
			}
		})
		return false
	}

	// 关闭模态框
	private handleCancelIdBack() {
		this.previewVisibleIdBack = false
	}

	private handlePreviewIdBack() {
		this.previewVisibleIdBack = true
	}

	private handleRemoveIdBack() {
		this.fileListIdBack = []
		this.idBackInfo = {}
	}

	private beforeUploadIdBack(e: any) {
		this.fileListIdBack = []
		this.idBackInfo = {}
		if (e.size > 2 * 1024 * 1024) {
			this.$message.error('文件大小不能超过2M')
			return false
		}
		const formData = new FormData()
		formData.append('filecontent', e)
		VisitorApi.operateAndUpload({
			formData,
			params: {
				cmd: 'imageMogr2/thumbnail/800x800',
			},
		}).then((res: any) => {
			this.fileListIdBack = [e]
			this.idBackInfo = res.data
			this.$message.success('上传成功')
		})
		return false
	}

	private loadManageArea(treeNode: any) {
		return this.$store.dispatch('setting/loadManageAreas', {
			treeNode,
			isCityLeaf: this.isCityLeaf,
			isAreaLeaf: this.isAreaLeaf,
		})
	}

	private selectVisitorRole(value: any) {
		this.manageAreas = []
		this.form.getFieldValue('manageAreas') &&
			this.form.setFieldsValue({
				manageAreas: [],
			})
		this.showManageTree = false
		this.setManageArea(value.key)
	}

	private setManageArea(permissionCode: string) {
		if (permissionCode === this.normalVisitor) {
			return
		}

		this.isCityLeaf = false
		this.isAreaLeaf = false
		const areas = cloneDeep(this.$store.state.setting.areas)
		if (permissionCode === '44000') {
			// 省份管理员
			for (const item of areas) {
				item.isLeaf = true
			}
			this.manageAreas = [
				{
					isLeaf: true,
					key: '000000',
					title: '全国',
					value: '000000',
				},
			].concat(areas)
		} else if (permissionCode === '45000') {
			// 市区管理员
			this.isCityLeaf = true
			areas.forEach((item: any) => {
				Object.assign(item, { disabled: true })
			})
			this.manageAreas = areas
		} else if (permissionCode === '46000') {
			// 区域管理员
			this.isAreaLeaf = true
			areas.forEach((item: any) => {
				Object.assign(item, { disabled: true })
			})
			this.manageAreas = areas
		}

		this.$nextTick(() => {
			this.showManageTree = true
		})
	}

	private uploadAvatar() {
		const input: any = this.$refs.uploadAvatar
		input.click()
	}

	private areaSearch(value: any) {
		return new Promise((resolve: any, reject: any) => {
			debounceSearch(() => {
				this.fetching = true
				AreaApi.searchArea(value)
					.then((res: any) => {
						this.searchArea = res.data.map((item: any) => {
							return {
								key: item.provCode + '-' + item.cityCode + '-' + item.areaCode,
								label: item.provName + item.cityName + item.areaName,
							}
						})
						resolve()
					})
					.finally(() => {
						this.fetching = false
					})
			})
		})
	}

	private onSelectManageArea(value: any, node: any, extra: any) {
		this.manageAreaMap[value.value] = node.dataRef.fullDesc
	}

	private doMod() {
		if (!this.imgURL) {
			return this.$message.error('请上传头像')
		}
		if (!this.idFrontInfo.picId) {
			return this.$message.error('请上传身份证人像面')
		}
		if (!this.idBackInfo.picId) {
			return this.$message.error('请上传身份证国徽面')
		}
		this.form.validateFields((err: any, values: any) => {
			if (!err) {
				const f = async () => {
					let res: any = ''
					const formData = new FormData()
					const canvas = cropper.getCroppedCanvas()
					const blob: any = this.dataURLtoBlob(
						canvas.toDataURL('image/jpeg'),
						'头像'
					)
					formData.append('filecontent', blob, blob.name)

					res = await VisitorApi.uploadImage({
						formData,
					})

					const picId = res.data.picId

					this.loading = true
					values = cloneDeep(values)
					values.picId = picId
					values.companyId = values.companyId.value
					const code = values.code.key.split('-')
					values.provinceCode = code[0]
					values.cityCode = code[1]
					values.countryCode = code[2]
					values.fullDesc = values.code.label
					delete values.code
					values.roleCode = values.permission.key
					values.roleName = values.permission.label
					// values.education = values.education.key
					// values.politics = values.politics.key
					values.career = values.career.key
					delete values.sex
					delete values.age
					values.manageAreas =
						values.manageAreas &&
						values.manageAreas.map((item: any) => {
							// 选择省份时manageAreaMap值为空
							let res = {
									areaName: this.manageAreaMap[item.value] || item.label,
								},
								codes = item.value.split('-')
							codes[0] && Object.assign(res, { provinceCode: codes[0] })
							codes[1] && Object.assign(res, { cityCode: codes[1] })
							codes[2] && Object.assign(res, { areaCode: codes[2] })
							return res
						})
					values.idFront = this.idFrontInfo.picId
					values.idBack = this.idBackInfo.picId
					if (this.isUpdate) {
						const selected = this.selected[0]
						values.visitorId = selected.id
						await VisitorApi.updateVisitor(values)
						this.$message.success('修改用户成功')
					} else {
						await VisitorApi.addVisitor(values)
						this.$message.success('添加用户成功')
					}

					this.$emit('input', false)
					this.visible = false
					this.$emit('ok')
					this.handleRemove()
					this.handleRemoveIdBack()
				}
				f().finally(() => {
					this.loading = false
				})
			}
		})
	}
	private cancel() {
		this.handleRemove()
		this.handleRemoveIdBack()
		this.$emit('input', false)
	}

	private dataURLtoBlob(dataurl: any, name: any) {
		const arr = dataurl.split(',')
		const mime = arr[0].match(/:(.*?);/)[1]
		const bstr = atob(arr[1])
		let n = bstr.length
		const u8arr = new Uint8Array(n)
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n)
		}
		const blob: any = new Blob([u8arr], { type: mime })
		blob.name = name
		return blob
	}

	private setCropper(url: string) {
		this.imgURL = url
		if (cropper) {
			cropper.replace(url)
		} else {
			this.$nextTick(() => {
				cropper = new Cropper(
					this.$refs.cropImg as any,
					{
						aspectRatio: 5 / 7,
						viewMode: 1,
						preview: this.$refs.previewImg,
						guides: false,
						background: false,
						autoCropArea: 1,
					} as any
				)
			})
		}
	}

	private removeCropper() {
		this.imgURL = ''
		cropper && cropper.destroy()
		cropper = undefined
	}

	private onLoad(e: any) {
		if (!e.target.files.length) {
			return
		}
		const fileReader = new FileReader()
		fileReader.readAsDataURL(e.target.files[0])
		fileReader.onload = () => {
			const file = this.dataURLtoBlob(fileReader.result, '头像')
			if (file.size > 1024 * 1024 * 2) {
				;(this.$refs.uploadAvatar as any).value = ''
				return this.$message.error('文件大小不能超过2M')
			}
			this.setCropper(fileReader.result as any)
			;(this.$refs.uploadAvatar as any).value = ''
		}
	}

	@Watch('value')
	private onVisibleChange() {
		if (this.value) {
			console.log(this.selected, 'selected')
			this.fileList = []
			this.fileListIdBack = []
			this.visible = true
			this.showManageTree = false
			this.manageAreaMap = {}
			this.$nextTick(() => {
				this.form && this.form.resetFields()

				this.removeCropper()
				if (this.selected) {
					const selected = this.selected[0]
					if (selected.picId) {
						VisitorApi.getPic(selected.picId).then((res: any) => {
							this.setCropper(res.data)
						})
					}
					VisitorApi.getVisitorInfo({ id: selected.id }).then((res: any) => {
						this.idFrontInfo.picId = res.data.idFront
						this.idFrontInfo.accessUrl = res.data.idFrontUrl
						this.idBackInfo.picId = res.data.idBack
						this.idBackInfo.accessUrl = res.data.idBackUrl
						if (this.idFrontInfo.picId !== '') {
							this.fileList = [
								{
									uid: '-1',
									name: '身份证人像面.png',
									status: 'done',
									url: this.idFrontInfo.accessUrl,
								},
							]
						}
						if (this.idBackInfo.picId !== '') {
							this.fileListIdBack = [
								{
									uid: '-1',
									name: '身份证国徽面.png',
									status: 'done',
									url: this.idBackInfo.accessUrl,
								},
							]
						}

						this.showManageTree = true
						const key = `${selected.provinceCode}-${selected.cityCode}-${selected.areaCode}`
						const label = selected.fullDesc
						// const education = {
						// 	key: selected.education,
						// 	label: this.$store.state.setting.educationMap[selected.education],
						// }
						// const politics = {
						// 	key: selected.politics,
						// 	label: this.$store.state.setting.politicsMap[selected.politics],
						// }
						const career = {
							key: selected.career,
							label: this.$store.state.setting.careerMap[selected.career],
						}
						const permission = {
							key: selected.roleCode,
							label: selected.roleName,
						}
						const manageAreas = selected.manageAreas.map((item: any) => {
							let value = item.provinceCode
							if (item.cityCode) {
								value += `-${item.cityCode}`
								if (item.areaCode) {
									value += `-${item.areaCode}`
								}
							}
							this.manageAreaMap[value] = item.areaName
							return {
								value: value,
								label: item.areaName,
							}
						})

						this.form.setFieldsValue({
							name: selected.name,
							mobile: selected.mobile,
							idNo: res.data.idNo,
							sex: res.data.sex,
							age: res.data.age,
							// education: education,
							// politics: politics,
							career: career,
							companyId: {
								value: selected.companyId + '',
								label: selected.company,
							},
							code: {
								key,
								label,
							},
							permission: permission,
						})
						this.$nextTick(() => {
							this.form.setFieldsValue({
								manageAreas: manageAreas,
							})
							this.setManageArea(permission.key)
						})
					})
				}
			})
		}
	}
}
